export default "__VITE_ASSET__DKx6NsJI__"